module.exports = __webpack_public_path__ + "static/media/atam.94856b7b.png";